import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import type { Follower } from '../types'

export const useCompanyFollowStore = defineStore('companyFollow', () => {
  const isCurrentUserFollowing = ref(false)
  const followers = ref<Record<string, string>>({})
  const currentUser = ref<Follower | null>(null)
  const followCount = computed(() => {
    const followerCount = Object.keys(followers.value).length
    return followerCount + (isCurrentUserFollowing.value ? 1 : 0)
  })
  const setInitialData = (
    initialFollowers: Follower[],
    initialCurrentUser: Follower
  ): void => {
    currentUser.value = initialCurrentUser

    isCurrentUserFollowing.value = initialFollowers.some(
      (follower) => follower.id.toString() === initialCurrentUser.id.toString()
    )

    followers.value = Object.fromEntries(
      initialFollowers
        .filter((follower) => follower.id !== initialCurrentUser.id)
        .map((follower) => [follower.id, follower.name])
    )
  }

  return {
    isCurrentUserFollowing,
    followers,
    setInitialData,
    followCount,
    currentUser,
  }
})
